/* eslint-disable */ import { DomainBuilder, DomainComponentOpticBuilder, InvariantBuilder, RecipeFactoryBuilder, commonAdminCustomExpressions, commonAdminViolationExpressions, createConstantExpressionFactory, createCustomExpressionFactory, createCustomInvariantFactory, createMapPublishedChunkedDataHandlerFactory, createMapPublishedRevisionDataHandlerFactory, createRelationFactory } from '@salsita-ai/platform-project-sdk/domain';
import { $entityReflections, constants } from './admin-enhanced-model.js';
import { AnyDomainEntity, RootEntity, aliases, entities, modelVersion } from './admin-model/index.js';
import { FrontendData, PublishedData, SessionData } from './application-types.js';
const implementRelation = createRelationFactory(aliases);
export const relationExpressions = {
    Admin: {
        $presets: implementRelation({
            kind: 'allOfType',
            target: 'Preset',
            cardinality: '0-N'
        }),
        $presetCategories: implementRelation({
            kind: 'allOfType',
            target: 'PresetCategory',
            cardinality: '0-N'
        }),
        $recipes: implementRelation({
            kind: 'allOfType',
            target: 'Recipe',
            cardinality: '0-N'
        }),
        $connectedDataConfigs: implementRelation({
            kind: 'allOfType',
            target: 'ConnectedDataConfig',
            cardinality: '0-N'
        }),
        $dataTables: implementRelation({
            kind: 'allOfType',
            target: 'DataTable',
            cardinality: '0-N'
        })
    },
    PresetCategory: {
        $admin: implementRelation({
            kind: 'allOfType',
            target: 'Admin',
            cardinality: '1-1'
        }),
        $presets: implementRelation({
            kind: 'indirect',
            field: 'categoryId',
            target: 'Preset',
            cardinality: '0-N'
        })
    },
    Preset: {
        $admin: implementRelation({
            kind: 'allOfType',
            target: 'Admin',
            cardinality: '1-1'
        }),
        $category: implementRelation({
            kind: 'direct',
            field: 'categoryId',
            target: 'PresetCategory',
            cardinality: '0-1'
        })
    },
    Recipe: {
        $admin: implementRelation({
            kind: 'allOfType',
            target: 'Admin',
            cardinality: '1-1'
        })
    },
    ConnectedDataConfig: {
        $admin: implementRelation({
            kind: 'allOfType',
            target: 'Admin',
            cardinality: '1-1'
        })
    },
    DataTable: {
        $admin: implementRelation({
            kind: 'allOfType',
            target: 'Admin',
            cardinality: '1-1'
        })
    }
};
export const constantExpressions = createConstantExpressionFactory({} // insert expression metas here, once ready
)(constants);
export const createAdminRecipe = RecipeFactoryBuilder.forAliases(aliases).forEntities(AnyDomainEntity.reflections).withDefaults({}).build();
const staticViolations = {};
export const implementCustomAdminInvariants = createCustomInvariantFactory()(staticViolations);
export const adminInvariantBuilder = new InvariantBuilder(aliases).withInvariants(implementCustomAdminInvariants(commonAdminViolationExpressions));
export const attachAdminComponent = DomainComponentOpticBuilder.from(aliases);
export const implementAdminCustomExpressions = createCustomExpressionFactory({} // TODO pass in meta-data once we have them
);
export const dataExpressions = implementAdminCustomExpressions({});
export const createMapPublishedRevisionDataHandler = createMapPublishedRevisionDataHandlerFactory();
export const createMapPublishedChunkedDataHandler = createMapPublishedChunkedDataHandlerFactory();
export const adminDomainBuilder = DomainBuilder.from(entities, aliases, $entityReflections, RootEntity.types, modelVersion, PublishedData, SessionData, FrontendData, undefined, true).withExpressions(constantExpressions).withExpressions(relationExpressions).withExpressions(implementAdminCustomExpressions(commonAdminCustomExpressions));

//# sourceMappingURL=admin-implementation.js.map